export class ApiResult<T> {
  public value: T;

  public errors: string[];

  public statusCode?: number;

  public get hasErrors(): boolean {
    return !!this.errors.filter((error) => error).length;
  }

  constructor(value: T, status?: number, ...errors: string[]) {
    this.value = value;
    this.statusCode = status;
    this.errors = errors.filter((error) => error).length ? errors : [];
  }
}
